import React from 'react'

import PropTypes from 'prop-types'
import colors from 'Assets/colors'
import Tooltip from '@material-ui/core/Tooltip'
import { useTranslation } from 'react-i18next'

import { RequestActionContainer, RequestRepeatOrder, HelpText } from './styled'

const ActionButton = ({ onClick, buttonText, helpText, color, Icon, disabled, orderState, smallCard, status }) => {
  const { t } = useTranslation()

  return (
    <Tooltip
      title={t('failedRequests.requestFailedAdviceCartTooltip')}
      arrow
      disableHoverListener={!disabled}
      placement='top'
    >
      <RequestActionContainer
        smallCard={smallCard}
        orderState={orderState}
        disabled={orderState || disabled}
        status={status}
      >
        <RequestRepeatOrder color={color} disabled={orderState || disabled} smallCard={smallCard} status={status}>
          {!smallCard && <Icon />}
          <button type='button' onClick={onClick} disabled={orderState || disabled}>
            {buttonText}
          </button>
        </RequestRepeatOrder>
        {!smallCard && <HelpText disabled={orderState || disabled}>{helpText}</HelpText>}
      </RequestActionContainer>
    </Tooltip>
  )
}

ActionButton.propTypes = {
  onClick: PropTypes.func,
  buttonText: PropTypes.string,
  helpText: PropTypes.string,
  Icon: PropTypes.object.isRequired,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  orderState: PropTypes.bool,
  smallCard: PropTypes.bool,
  status: PropTypes.string,
}

ActionButton.defaultProps = {
  onClick: () => null,
  buttonText: '',
  helpText: '',
  color: colors.black,
  disabled: false,
  orderState: false,
  smallCard: false,
  status: null,
}

export default ActionButton
